import React from 'react';
import {Button, Header, Icon, Modal, Form} from 'semantic-ui-react';
import ApiActions from 'go/actions/api';
import FocusTrap from 'focus-trap-react';
import {connect} from 'react-redux';

const TimeoutModal = ({
  refreshToken,
  token,
  isTimeoutModalActive,
  toggleTimeoutModal,
}) => {
  const ignoreDefaultWithConfirm = (e) => {
    e.stopPropagation();
    e.preventDefault();
    refreshToken(token);
    toggleTimeoutModal(false);
  };

  let modal = null;
  if (isTimeoutModalActive) {
    modal = (
      <FocusTrap>
        <Modal open={true} size={'tiny'} onClose={ignoreDefaultWithConfirm}>
          <Modal.Content>
            <Header as="h2" content="Warning: Inactive Session" />
            {
              'You are about to be logged out.  If you wish to extend your session, press Continue.'
            }
            <Form style={{paddingTop: '24px'}}>
              <Form.Field>
                <Button
                  title="Continue"
                  primary={true}
                  onClick={ignoreDefaultWithConfirm}
                >
                  {'Continue'}
                </Button>
              </Form.Field>
            </Form>
          </Modal.Content>
        </Modal>
      </FocusTrap>
    );
  }
  return modal;
};

const mapStateToProps = (state) => {
  return {
    isTimeoutModalActive: state.auth ? state.auth.isTimeoutModalActive : false,
    token: state.auth ? state.auth.token : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  refreshToken: (token) => {
    const action = ApiActions.auth.refresh(token);
    return dispatch(action);
  },
  toggleTimeoutModal: (toggle) => {
    const action = ApiActions.auth.toggleTimeoutModal(toggle);
    return dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeoutModal);
